module.exports = __webpack_public_path__ + "img/销售明细1.464341ce.svg";